export default new class {

    Android() {
        return navigator.userAgent.match(/Android/i);
    }
    iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }
    Windows() {
        return navigator.userAgent.match(/IEMobile/i);
    }
    any() {
        return (this.Android() || this.iOS() || this.Windows());
    }
    //alias browser -> any
    browser(){
        // TODO REFACTOR
        // if (window.hasOwnProperty('cordova') === false) {
        //     return true;
        // } else {
        //     return false;
        // }
    }
}